import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantOnboardingCheckService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Participant_ParticipantOnboardingCheckDto,
} from '../../services/wealthlane-customer-services';
import { useSelector } from 'react-redux';
import { selectTenantId } from '../../pages/configuration/participantSignupSlice';

const useGetParticipantOnboardingStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  token: string | null
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Participant_ParticipantOnboardingCheckDto | undefined,
  unknown
> => {
  const id = useSelector(selectTenantId);

  const participantOnboardingStatus = useQuery(
    ['getParticipantOnboardingStatus', token, id],
    async () => {
      if (token != null && id !== null) {
        return await handleRequest(
          ParticipantOnboardingCheckService.getApiCustomerApiAppParticipantOnboardingCheckCheckParticipantOnboardingStatus()
        );
      }
    }
    // {
    //   enabled:
    //     typeof token === 'string' && token != null && token !== '' && id != null && id !== '',
    // }
  );

  return participantOnboardingStatus;
};

export default useGetParticipantOnboardingStatus;
